<template>
  <div>
    <protocol-header v-if="protocol"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <div class="row mt-4">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
          </div>
          
          <div class="card-body shadow-none">
            
            <div class="form-group">
              <a href="#" class="btn btn-outline-primary btn-block btn-lg"
                 @click.prevent="showFinancing = !showFinancing">{{
                  showFinancing ? 'Ocultar financiamiento' : 'Ver financiamiento'
                                                                 }}</a>
            </div>
            
            <div class="financing-information" v-show="showFinancing">
              <protocol-financing :protocol="protocol"
                                  @saved-financing-information="showFinancing = !showFinancing"
                                  :editable="false"></protocol-financing>
            </div>
            
            <div v-show="!showFinancing">
              <div class="form-group">
                <p>Periodo de desarrollo: <strong>
                  {{ formatDate(protocol.start_date) }} a {{ formatDate(protocol.end_date) }}</strong></p>
              </div>
              
              <div class="form-group" v-if="protocol.development_request">
                <div>Periodo real de desarrollo: <strong>
                  {{ realStartDate }} a
                  {{ realEndDate }}</strong>
                  <button type="button"
                          class="btn btn-primary btn-sm ml-1"
                          @click="editing = !editing">{{ editing ? 'Cancelar' : 'Editar' }}
                  </button>
                </div>
              </div>
              
              <form id="frm-update-dates"
                    ref="form-dates"
                    accept-charset="UTF-8"
                    class="border-top border-gray-500 pt-4"
                    onsubmit="return false"
                    v-show="editing">
                
                <div class="form-row">
                  <hr>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="d-block font-weight-normal"
                             for="real_start_date">Fecha real de inicio:
                        <abbr style="text-decoration: none;"
                              title="Campo obligatorio">*</abbr>
                      </label>
                      
                      <input type="date"
                             name="real_start_date"
                             id="real_start_date"
                             class="form-control"
                             v-model="realStartDate"/>
                    </div>
                  </div>
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="d-block font-weight-normal"
                             for="real_end_date">Fecha real de término:
                        <abbr style="text-decoration: none;"
                              title="Campo obligatorio">*</abbr>
                      </label>
                      
                      <input type="date"
                             name="real_end_date"
                             id="real_end_date"
                             class="form-control"
                             v-model="realEndDate"/>
                    </div>
                  </div>
                  
                  <div class="col">
                    <button type="button"
                            class="btn btn-primary"
                            @click="updateDevDates"
                            :disabled="savingDates">
                      <span class="spinner-border text-white spinner-border-sm" role="status" v-if="savingDates">
                        <span class="sr-only">Guardando...</span>
                      </span>
                      Actualizar fechas
                    </button>
                  </div>
                </div>
                
                <hr>
              </form>
              
              <form id="frm-evaluation"
                    ref="form"
                    accept-charset="UTF-8"
                    method="GET"
                    onsubmit="return false">
                <div class="form-group">
                  <p class="font-weight-bold font-size-lg">¿Válida el desarrollo del proyecto?</p>
                </div>
                
                <div class="form-group">
                  <label class="d-inline-block font-weight-normal mr-3">Evaluación:
                    <abbr style="text-decoration: none;"
                          title="Campo obligatorio">*</abbr>
                  </label>
                  
                  <div class="d-inline-block">
                    <input type="radio"
                           id="evaluation_yes"
                           name="evaluation"
                           value="1"
                           v-model="evaluation"/>
                    <label for="evaluation_yes" class="d-inline-block mr-3">Sí</label>
                  </div>
                  
                  <div class="d-inline-block">
                    <input type="radio"
                           id="evaluation_no"
                           name="evaluation"
                           value="0"
                           v-model="evaluation"/>
                    <label for="evaluation_no">No</label>
                  </div>
                  
                  <div class="d-block w-100 error-bag"></div>
                </div>
                
                <div class="form-group">
                  <label class="d-inline-block font-weight-normal mr-3"
                         for="comments">Comentarios:
                    <abbr style="text-decoration: none;"
                          title="Campo obligatorio">*</abbr>
                  </label>
                  
                  <textarea name="comments"
                            id="comments"
                            rows="5"
                            cols="5"
                            placeholder="Escriba sus comentarios"
                            class="form-control"
                            v-model="comments"></textarea>
                </div>
                
                <div class="form-group">
                  <button type="button"
                          class="btn btn-primary btn-lg"
                          @click="confirmEvaluation">Registrar evaluación de desarrollo de protocolo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <portal to="task-modals">
      <ok-cancel-dialog title="Validar incorporación a apertura programática"
                        id="register-evaluation-modal"
                        ref="register-evaluation-modal"
                        content="<p>¿Esta seguro de enviar la evaluación?</p>"
                        ok-button-text="Confirmar"
                        :ok-callback="validateDevRequest"></ok-cancel-dialog>
    </portal>
  </div>
</template>
<script>
  import ProtocolHeader from './ProtocolHeader'
  import autosize from 'autosize'
  import 'jquery-validation'
  import moment from 'moment'
  import { mapActions, mapMutations } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import ProtocolFinancing from './ProtocolFinancing'
  
  export default {
    name: 'ApproveProtocolDevelopmentRequest',
    components: {
      OkCancelDialog,
      ProtocolHeader,
      ProtocolFinancing,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        editing: false,
        evaluation: null,
        comments: null,
        savingDates: false,
        showFinancing: false,
        realStartDate: this.formatDate(this.protocol.development_request.real_start_date),
        realEndDate: this.formatDate(this.protocol.development_request.real_end_date),
      }
    },
    methods: {
      ...mapActions({
        updateDates: 'protocols/updateProtocolRealDates',
        validateProtocolDevelopmentRequest: 'protocols/validateProtocolDevelopmentRequest',
      }),
      
      ...mapMutations({
        setProtocol: 'protocols/SET_SELECTED_PROTOCOL',
      }),
      
      confirmEvaluation () {
        if (!$(this.$refs.form).valid()) {
          return false
        }
        
        $('#register-evaluation-modal').modal()
      },
      async validateDevRequest () {
        const {
                evaluation,
                comments,
                protocol,
              } = this
        
        const response = await this.validateProtocolDevelopmentRequest({
          protocol,
          development: protocol.development_request,
          evaluation,
          comments,
        })
        
        const {
                error,
                status,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      },
      async updateDevDates () {
        if (!$(this.$refs['form-dates']).valid()) {
          return false
        }
        
        const {
                protocol,
                realStartDate,
                realEndDate,
              } = this
        
        this.savingDates = true
        
        const response = await this.updateDates({
          protocol,
          development: protocol.development_request,
          real_start_date: moment(realStartDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          real_end_date: moment(realEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        })
        
        this.savingDates = false
        
        const {
                status,
                error,
                message,
                development,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.real_start_date = null
        this.real_end_date   = null
        this.editing         = false
      },
    },
    mounted () {
      const vm = this
      
      this.setProtocol(this.protocol)
      
      autosize(document.getElementById('comments'))
      
      const minDate = moment(this.task.min_date)
      
      const $startDate = $('#real_start_date')
      const $endDate   = $('#real_end_date')
      
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        minDate: minDate.format('DD/MM/YYYY'),
        onChange (dates, dateStr, instance) {
          const date = moment(dates[0]).add(1, 'd').format('DD/MM/YYYY')
          vm.endDate.set('minDate', date)
        },
      })
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        minDate: minDate.format('DD/MM/YYYY'),
      })
      
      this.startDate = $startDate.get(0)._flatpickr
      this.endDate  = $endDate.get(0)._flatpickr
      
      $.validator.addMethod('after', function (value, element, param) {
        const start = moment($(param).val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const end   = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        
        return $(param).val() !== '' && value !== '' && moment(end).isAfter(start)
      }, 'La fecha de término debe ser posterior a la fecha de inicio.')
      
      $(this.$refs['form-dates']).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          real_start_date: {
            required: true,
          },
          real_end_date: {
            required: true,
            after: '#real_start_date',
          },
        },
        messages: {
          real_start_date: {
            required: 'Seleccione la fecha real de inicio.',
          },
          real_end_date: {
            required: 'Seleccione la fecha real de término.',
          },
        },
      })
      
      $(this.$refs.form).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (error, element) {
          error.addClass('invalid-feedback')
          
          if (element[0].type.toLowerCase() === 'radio') {
            element.parents('.form-group').find('.error-bag').html(error)
          }
          else {
            error.insertAfter(element)
          }
        },
        rules: {
          evaluation: {
            required: true,
          },
          comments: {
            required: true,
          },
        },
        messages: {
          evaluation: {
            required: 'Seleccione una opción.',
          },
          comments: {
            required: 'Escriba sus comentarios.',
          },
        },
      })
    },
  }
</script>
